import { ValueOf } from '../../utils';

export enum FEE_ITEM_TYPE {
  Points = 'points',
  Total = 'total',
  Taxes = 'taxes',
  RebookingFee = 'rebookingFee',
  Flight = 'flight',
  DiscountedPoints = 'discountedPoints',
  Seat = 'seat',
  Meals = 'meals',
}

export type FeeItem = {
  amount: number;
  label?: string;
  labelDetails?: string;
  itemType: FEE_ITEM_TYPE;
  discountedPoints?: number;
  priceType: 'revenue' | 'points';
  details?: PriceBreakdown[] | undefined;
};

export type PriceBreakdown = {
  amount: number;
  currency?: string;
  label: string;
};

export type CartOfferMutationType = ValueOf<typeof CartOfferMutationType>;
export const CartOfferMutationType = {
  PRICE_CHANGE: 'priceChange',
  OFFER_REMOVED: 'offerRemoved',
} as const;
